import request from '@/utils/request'

/**
 * 智享库列表
 */
export function getShareDataList(data) {
  return request({
    url: 'api/getShareList',
    method: 'post',
    params: data
  })
}

/**
 * 智享库详情
 */
export function getShareDataDetail(data) {
  return request({
    url: 'api/getShareDetail',
    method: 'post',
    params: data
  })
}

/**
 * 获取文件信息
 */
export function getFileDownload(data) {
  return request({
    url: 'fileUpload/getFileDownload',
    method: 'post',
    params: data
  })
}



/**
 * 预览文件
 */
export function previewFileYz(data) {
  return request({
    url: 'fileUpload/previewFileYz2',
    method: 'post',
    params: data
  })
}

/**
 * 添加智享库
 */
export function addShare(data) {
  return request({
    url: 'api/addShareData',
    method: 'post',
    params: data
  })
}
